export enum CommonErrorEnum {
  NOT_ALLOWED_TO_DELETE_SUPPLY_CHAIN_ATTACHMENT = "NOT_ALLOWED_TO_DELETE_SUPPLY_CHAIN_ATTACHMENT",
  NOT_ALLOWED_TO_DELETE_MAPPED_RECORD = "NOT_ALLOWED_TO_DELETE_MAPPED_RECORD",
}
